/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './businessName.module.scss';
import { useThemeMode } from '../../../../states/contexts/theme';
import { TReservedOrderDetails } from '../../../../states/reservedOrdersState/models/reservedOrderDetails';
interface Props {
    order: TReservedOrderDetails
}
const BusinessName: React.FC<Props> = ({ order }) => {
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.business_name} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.order_number} >
                {
                    theme === 'dark' ? <img className={styles.confirmation} src="/confirmation-number-white.svg" alt="" width={20} height={20} /> :
                        <img className={styles.confirmation} src="/confirmation-number.webp" alt="" width={20} height={20} />
                }
                {/* <span>{reservedOrderDetails?.business_name || 'Seyco Invoice No.'} : {reservedOrderDetails?.client_order_number}</span> */}
                <span>{'Order #'} : {order?.client_order_number}</span>
            </div>
            <h5>A$ {order?.transport_original_price}</h5>
        </div>
    )
}
export default BusinessName;